export default __webpack_public_path__ + "static/media/welcome_graphic.559c25fc.png";